import AxiosHelper from "@/helpers/AxiosHelper.js";

export default {
  markAsRead(alertId) {
    return AxiosHelper.inspectionClient.post(`/v1/alerts/read/${alertId}`);
  },
  markAsUnread(alertId) {
    return AxiosHelper.inspectionClient.post(`/v1/alerts/unread/${alertId}`);
  },
  switchPinAlert(alertId) {
    return AxiosHelper.inspectionClient.post(`/v1/alerts/switch-pin/${alertId}`);
  },
  getUserAlerts(form) {
    return AxiosHelper.inspectionClient.post(`/v1/alerts`, form);
  },
  getPassengerAlerts(form) {
    return AxiosHelper.inspectionClient.post(`/v1/alerts/passenger`, form);
  },
  getVUAlerts(form) {
    return AxiosHelper.inspectionClient.post(`/v1/alerts/vu`, form);
  },
  deleteAlerts(ids) {
    return AxiosHelper.inspectionClient.delete(
      "/v1/alerts/deleteAlerts",
      {
        params: {
          ids,
        },
      }
    );
  },
  deleteAllAlerts() {
    return AxiosHelper.inspectionClient.delete("/v1/alerts/deleteAll");
  },
  getCount(type) {
    let params = type ? { params: { type: type } } : undefined;
    return AxiosHelper.inspectionClient.get(`/v1/alerts/count`, params);
  },
  exportAlert(form) {
    return AxiosHelper.inspectionClient.post(
      "/v1/alerts/report",
      form,
      {
        responseType: "arraybuffer",
      }
    );
  },
};
